module.exports = __webpack_public_path__ + "static/media/logo.50188e96.png";